'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var TestimonialItem = require('./components/TestimonialItem.js');
var Slider = require('../../core/DsSlider/Slider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TestimonialCarousel = (_a) => {
  var _b = _a, {
    items,
    commonStyle,
    contentStyle,
    nameStyle,
    titleStyle,
    imageStyle,
    bubbleStyle,
    width,
    alignment = "center",
    layout,
    skin
  } = _b, sliderConfig = __objRest(_b, [
    "items",
    "commonStyle",
    "contentStyle",
    "nameStyle",
    "titleStyle",
    "imageStyle",
    "bubbleStyle",
    "width",
    "alignment",
    "layout",
    "skin"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(StyledTestimonialCarousel, {
    commonStyle,
    children: /* @__PURE__ */ jsxRuntime.jsx(Slider.DSSlider, __spreadProps(__spreadValues({}, sliderConfig), {
      children: items.map((testimonial, index) => /* @__PURE__ */ jsxRuntime.jsx(ItemWrapper, {
        alignment,
        children: /* @__PURE__ */ jsxRuntime.jsx(TestimonialItem.TestimonialItem, __spreadProps(__spreadValues({}, testimonial), {
          skin,
          contentStyle,
          titleStyle,
          nameStyle,
          imageStyle,
          bubbleStyle,
          width,
          alignment,
          layout
        }))
      }, index))
    }))
  });
};
const StyledTestimonialCarousel = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
  `
);
const ItemWrapper = styled__default["default"].div(
  ({ alignment }) => `
    display: flex;
    justify-content: ${alignment === "left" ? "flex-start" : alignment === "right" ? "flex-end" : "center"};
`
);
TestimonialCarousel.displayName = "TestimonialCarousel";

exports.TestimonialCarousel = TestimonialCarousel;
